import React, { FC } from 'react';
import { Image } from 'react-native';

import { Theme } from '@constants';

import { ANIMATED_ICON_PATH_MAP } from '../../../assets/icons/animated/animated_icon_path_map';
import { ICON_MAP_CURRENT, ICON_MAP_FORECAST } from '../../../assets/icons/icon_map';

export const TWCAnimatedIcon: FC<TWCAnimatedIconProps> = ({ code, type = 'forecast', height = 48, width = 48 }) => {
  const iconMap = type === 'current' ? ICON_MAP_CURRENT : ICON_MAP_FORECAST;
  const gif = ANIMATED_ICON_PATH_MAP[iconMap[code]];

  return <Image source={gif} style={{ height: Theme.px(height), width: Theme.px(width) }} />;
};

type TWCAnimatedIconProps = {
  code: keyof typeof ICON_MAP_CURRENT & keyof typeof ICON_MAP_FORECAST;
  height?: number;
  type?: 'current' | 'forecast';
  width?: number;
};
